import React, { useState } from "react";

import { useNavigate } from "react-router-dom";

function Login() {
  const [errorMessages, setErrorMessages] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const Navigat = useNavigate();
  // User Login info
  const database = [
    {
      username: "user1",
      password: "pass1",
    },
    {
      username: "user2",
      password: "pass2",
    },
  ];

  const errors = {
    uname: "invalid username",
    pass: "invalid password",
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    var { uname, pass } = document.forms[0];

    const userData = database.find((user) => user.username === uname.value);

    if (userData) {
      if (userData.password !== pass.value) {
        // Invalid password
        setErrorMessages({ name: "pass", message: errors.pass });
      } else {
        Navigat("/product");
        alert("Login Successfully");
      }
    } else {
      // Username not found
      setErrorMessages({ name: "uname", message: errors.uname });
    }
  };

  const renderErrorMessage = (name) =>
    name === errorMessages.name && (
      <div className="error">{errorMessages.message}</div>
    );

  return (
    <>
      <div class="vh-100 mt-5 pt-5 d-flex justify-content-center align-items-center">
        <div class="container">
          <div class="row d-flex justify-content-center">
            <div class="col-12 col-md-8 col-lg-6">
              <div class="border border-3 border-primary"></div>
              <div class="card bg-white">
                <div class="card-body p-5">
                  <form onSubmit={handleSubmit} class="mb-3 mt-md-4">
                    <h2 class="fw-bold mb-2 text-uppercase ">
                      DigiOpen Services
                    </h2>
                    <p class=" mb-5">Please enter your login and password!</p>
                    <div class="mb-3">
                      <label for="email" class="form-label ">
                        Email address
                      </label>
                      <input
                        type="uname"
                        id="email"
                        name="uname"
                        className="form-control"
                      />
                      {renderErrorMessage("uname")}
                    </div>
                    <div class="mb-3">
                      <label for="password" class="form-label ">
                        Password
                      </label>
                      <input
                        type="password"
                        id="password"
                        name="pass"
                        className="form-control"
                      />
                      {renderErrorMessage("pass")}
                    </div>
                    <p class="small">
                      <a class="text-primary" href="forget-password.html">
                        Forgot password?
                      </a>
                    </p>
                    <div class="d-grid">
                      <button class="btn btn-outline-dark" type="submit">
                        Login
                      </button>
                    </div>
                  </form>
                  <div>
                    <p class="mb-0  text-center">
                      Don't have an account?{" "}
                      <a href="signup.html" class="text-primary fw-bold">
                        Sign Up
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
